module.exports = __webpack_public_path__ + "static/media/banner-home-original.fe5d3ddd.jpg";